import { getMonthNames } from './localeUtils';

export const getLocaleDate = (date?: Date, locale?: string) => {
  if (!date) return '';

  const monthNames = getMonthNames(locale);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const monthName = monthNames[monthIndex];

  return `${day} ${monthName}`;
};
